import { portfolioConfig } from '../../../config';

export interface TimelineEvent {
  id: number;
  title: string;
  description: string;
  location: string;
  startdate: Date;
  enddate?: Date;
  link?: string;
}

export const timelineEvents: TimelineEvent[] = portfolioConfig.timeline.map((event) => ({
  id: Number(event.id),
  title: event.title,
  description: event.description,
  location: event.location,
  startdate: new Date(event.startDate),
  enddate: event.endDate ? new Date(event.endDate) : undefined,
  link: event.link,
}));
